﻿import { catchError, distinctUntilChanged, filter, map, of, switchMap, tap } from 'rxjs';
import { ofType } from 'redux-observable';
import uiStateSlice from 'layout/redux/uiStateSlice';
import modalService from 'layout/services/modalService';
import {
  getBuildeablePlanCard$,
  getCommunityExtendCard$,
  getPlanExtendCard$,
  getSpecExtendCard$,
} from '../apis/getExtendedCard';

const actions = uiStateSlice.actions;

/**
 * Epic to get the buidleable plan card observable to get the flyover.
 * 
 * You may notice some filters and distinctUntilChanged before the ofType function, 
 * it is needed caused by following scenario:
 * 
 * When user open the flyover, and click any button of the leads and click  back button, 
 * or click the same button of the map, the flyover request is maked again,
 * since the reducer of uiState need to change the prevoius HTML keys (the flyover), but the housing product is
 * the same. For this reason we need the distinctUntilChanged, to analysis if the id of the housing product change.
 * 
 * Then we face the other scenario when user open the flyover, close it and then open again the same card,
 * the ofType function don't allow to execute the distinctUntilChanged and the value never change, event though
 * the properties were set to null. To fix, we need to filter the action to avoid execute the distinctUntilChanged
 * when another action is fired, just clearModal and fetchModal actions, and the ask if the value change.
 * Then if the action is fetchModal we make the request.
 * 
 */
export const getBuildeablePlanEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type === actions.fetchModal.type ||
    action.type === actions.clearModal.type),
    distinctUntilChanged((previous, current) => previous?.payload?.parameters?.id === current?.payload?.parameters?.id),
    ofType(actions.fetchModal.type),
    filter((action) => action.payload.parameters.type === 'buildeablePlan'),
    map((action) => action.payload.parameters?.id),
    switchMap((id) =>
      getBuildeablePlanCard$(id).pipe(
        switchMap((data) => of(actions.fetchModalFulfilled(data))),
        tap((data) => modalService.setHtml(data)),
        catchError((err) => of(actions.fetchModalError(err)))
      )
    )
  );

export const getCommunityEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type === actions.fetchModal.type ||
    action.type === actions.clearModal.type),
    distinctUntilChanged((previous, current) => previous?.payload?.parameters?.id === current?.payload?.parameters?.id),
    ofType(actions.fetchModal.type),
    filter((action) => action.payload.parameters.type === 'community'),
    map((action) => action.payload.parameters?.id),
    switchMap((id) =>
      getCommunityExtendCard$(id).pipe(
        switchMap((data) => of(actions.fetchModalFulfilled(data))),
        tap((data) => modalService.setHtml(data)),
        catchError((err) => of(actions.fetchModalError(err)))
      )
    )
  );

export const getPlanEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type === actions.fetchModal.type ||
    action.type === actions.clearModal.type),
    distinctUntilChanged((previous, current) => previous?.payload?.parameters?.id === current?.payload?.parameters?.id),
    ofType(actions.fetchModal.type),
    filter((action) => action.payload.parameters.type === 'plan'),
    map((action) => action.payload.parameters?.id),
    switchMap((id) =>
      getPlanExtendCard$(id).pipe(
        switchMap((data) => of(actions.fetchModalFulfilled(data))),
        tap((data) => modalService.setHtml(data)),
        catchError((err) => of(actions.fetchModalError(err)))
      )
    )
  );

export const getSpecEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type === actions.fetchModal.type ||
    action.type === actions.clearModal.type),
    distinctUntilChanged((previous, current) => previous?.payload?.parameters?.id === current?.payload?.parameters?.id),
    ofType(actions.fetchModal.type),
    filter((action) => action.payload.parameters.type === 'spec'),
    map((action) => action.payload.parameters?.id),
    switchMap((id) =>
      getSpecExtendCard$(id).pipe(
        switchMap((data) => of(actions.fetchModalFulfilled(data))),
        tap((data) => modalService.setHtml(data)),
        catchError((err) => of(actions.fetchModalError(err)))
      )
    )
  );
